import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { getIsValidHashtag, getIsValidNickname } from '@util/string';

interface IState {
  // mode: 'shelves' | 'shelf' | 'bookmark' | 'subscription';
  shelfKey: string | null;
  isHashtagEdit: boolean;
  newHashtag: string | null;
  isHashtagValid: boolean;
  isHashtagError: boolean;
  // shelfMode: TShelfMode;
  categoryKey: string | null;
}

const initialState: IState = {
  // mode: 'shelves',
  shelfKey: null,
  isHashtagEdit: false,
  newHashtag: null,
  isHashtagValid: true,
  isHashtagError: false,
  // shelfMode: 'all',
  categoryKey: null,
};

const resetHashtagState = (state: Draft<IState>) => {
  state.isHashtagEdit = false;
  state.newHashtag = null;
  state.isHashtagValid = true;
  state.isHashtagError = false;
};

const newsletterSlice = createSlice({
  name: 'newsletter',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
    // clickShelfItem: (state, action: PayloadAction<string>) => {
    //   state.shelfKey = action.payload;
    //   state.mode = 'shelf';
    // },
    // clickShelfClose: (state) => {
    //   for (const key in state) {
    //     state[key] = initialState[key];
    //   }
    // },
    clickHashtag: (state) => {
      state.isHashtagEdit = true;
    },
    cancelHashtagEdit: (state) => resetHashtagState(state),
    completeHashtagEdit: (state) => resetHashtagState(state),
    editHashtag: (state, action: PayloadAction<React.ChangeEvent<HTMLInputElement>['target']>) => {
      const newHashtag = action.payload.value.trim();
      const isValid = getIsValidHashtag(newHashtag);
      isValid ? (state.isHashtagValid = true) : (state.isHashtagValid = false);
      state.newHashtag = action.payload.value.trim();
    },
    showHashtagError: (state) => {
      state.isHashtagError = true;
    },
    hideHashtagError: (state) => {
      state.isHashtagError = false;
    },
    clickCategory: (state, action: PayloadAction<string | null>) => {
      state.categoryKey = action.payload;
    },
  },
});

export const actions = newsletterSlice.actions;
export default newsletterSlice.reducer;
